<script>
import { ArrowUpIcon, VideoIcon,  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon, } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";
import countTo from "vue-count-to";

import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Footer from "@/components/footer";
import {post} from "@/assets/js/utils";
import config from "@/config.json";

/**
 * Index-services component
 */
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf("mac") > 0? 'mac' : 'win';
    return {
      os: os,
      downloadUrl: '#',
    };
  },
  mounted() {
    this.getRelease();
  },
  methods: {
    async getRelease() {
      try {
        const data = await post(`${config.api.latestrelease}`, {app: "Desktop.Mirror"});
        if (data.errno === 0) {
          const release = data.data;
          this.downloadUrl = (this.os === "mac")? release.mac_url : release.win_url;
          console.log(this.downloadUrl);
          document.getElementById('download-url').href = this.downloadUrl;
        } else {
        }
      } catch (e) {
        console.log(e.toString());
      }
    },
  },
  components: {
    Navbar,
    Carousel,
    Slide,
    ArrowUpIcon,
    VideoIcon,
      FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
    countTo,
    Footer,
    Features
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 d-table w-100" id="home">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7">
            <div class="title-heading mt-4">
              <h1 class="heading mb-3"> {{$t('figma.title')}} </h1>
              <p class="para-desc text-muted">{{$t('figma.description')}} </p>
              <div class="mt-4 pt-2">
                <h3>{{$t('figma.install.title')}}</h3>
                <ul class="list-unstyled">
                  <li v-for="(item, index) in $t('figma.install.steps')">
                    <span class="text-primary h5 mr-2"><i class="uil uil-check-circle align-middle"></i></span>
                    <span v-html="item"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <img src="images/photoshop/figma-install.png" alt="" width="1024" />
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
    <!--end section-->

    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

sstyle>
</style>
